import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'
import IconButton from '@mui/material/IconButton'
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'

import { useQuery, useCommand } from '~/client/hooks/cqrpc'
import ErrorMessage from '~/client/components/ErrorMessage'
import Timestamp from '~/client/components/Timestamp'
import LoadingList from '~/client/components/LoadingList'

export const routeOptions = {
  mustBeUser: true
}

export default function Page() {
  const query = useQuery('notifications.getAll')
  const deleteAllCmd = useCommand('notifications.destroyAll', {
    onSuccess(){ query.reload() }
  })
  return <Container sx={{p: 2}} maxWidth="sm">
    <Stack direction="row" justifyContent="space-between" sx={{mb: 2}}>
      <Typography variant="h4">Notifications</Typography>
      <IconButton onClick={() => { deleteAllCmd.call() }}>
        <DeleteForeverIcon/>
      </IconButton>
    </Stack>
    <ErrorMessage error={deleteAllCmd.error}/>
    <Paper elevation={2}>
      <ErrorMessage error={query.error} />
      <NotificationsList {...{
        loading: query.loading,
        notifications: query.result,
      }}/>
    </Paper>
  </Container>
}

function NotificationsList({ loading, notifications }){
  return <LoadingList {...{
    loading,
    emptyMessage: `you dont have any notifications`,
    members: notifications && notifications.map(n => ({
      key: n.id,
      // href: `/login-attempts/${n.loginAttemptId}`,
      icon: <NotificationsActiveIcon sx={{ml: 2}}/>,
      text: n.text,
      subtext: <Timestamp at={n.createdAt}/>,
    }))
  }}/>
}
